module.exports = __webpack_public_path__ + "static/media/CreatingEffectiveDesignSystems.006c5b5a.png";